import { createSlice } from '@reduxjs/toolkit';

export const defaultLocale = 'en';

const i18n = createSlice({
  name: 'i18n',
  initialState: {
    locale: defaultLocale,
  },
  reducers: {
    setLocale(state, action) {
      state.locale = action.payload;
    },
  },
});

// ACTIONS
export const i18nActions = {
  ...i18n.actions,
};

export default i18n;
